import { apiCrudBuilder, baseUrl } from "components/shared/apiCrudBuilder";

const path = `${baseUrl}/people-weight`;

export const { useGetAll: useAllPeopleWeight } = apiCrudBuilder(
  path,
  "PeopleWeight",
);
